export const TERMINOLOGY = {
  /**
   * 기능 명칭(Feature) SSOT — "자동매매" 대신 "스마트 주문" 을 사용한다.
   * 언어 모드에 맞춰 표기한다: 한국어 모드 "스마트 주문" / 영어 모드 "Smart Order". (한영 병기 금지)
   *
   * ⚠️ 상품 표시명(Product Display Name)과 구분한다.
   *    결제/구독 화면에 노출되는 부가상품 표시명은 PG 심의 대응을 위해
   *    migrations/0093 에서 "퀀트 데이터 피드 & 웹훅" 계열로 확정되었고,
   *    그 SSOT 는 운영 D1 `addon_configs.name` 이다. 이 파일에서 임의로 바꾸지 않는다.
   */
  AUTOTRADING: {
    id: 'addon_agent_pro',
    ko: '스마트 주문',
    en: 'Smart Order',
    simulation_ko: '시그널 레이더',
    simulation_en: 'Signal Radar',
  },
  AGENT: {
    id: 'addon_agent_standard',
    ko: '시그널 레이더 (Signal Radar)',
    en: 'Signal Radar',
  },
  CHAT_PLUS: {
    id: 'CHAT_PREDICTION_ADDON',
    ko: 'AI Chat Plus',
    en: 'AI Chat Plus',
  },
  AI_PERSONALIZATION: {
    id: 'AI_PERSONALIZATION_ADDON',
    ko: 'AI 모델 개인화',
    en: 'AI Model Personalization',
  },
  API_ACCESS: {
    id: 'API_ACCESS_ADDON',
    ko: 'Developer API',
    en: 'Developer API',
  },
  OPTIONS_ANALYTICS: {
    id: 'OPTIONS_ANALYTICS_ADDON',
    ko: '옵션/공매도 분석',
    en: 'Options/Shorts Analytics',
  }
} as const;
